const schedulingConstants = Object.freeze({
  SESSION_TYPES: {
    PAID_SERVICE_INDIVIDUAL: 'paid-service-individual',
    FREE_SERVICE_INDIVIDUAL: 'free-service-individual',
    FREE_DISCOVERY: 'free-discovery',
  },
});

export default schedulingConstants;
